var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.588,
    height: 15.451,
    viewBox: "0 0 17.588 15.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "terms",
    transform: "translate(-158.92 -202.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17112",
    "data-name": "Group 17112",
    transform: "translate(165.392 210.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38266",
    "data-name": "Path 38266",
    d: "M0,0H6.068V.484H0Z",
    transform: "translate(0 4.29) rotate(-45)",
    stroke: "#898d93",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17113",
    "data-name": "Group 17113",
    transform: "translate(165.064 210.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38267",
    "data-name": "Path 38267",
    d: "M403.749,489.838a1.089,1.089,0,1,1,1.089-1.089A1.09,1.09,0,0,1,403.749,489.838Zm0-1.694a.6.6,0,1,0,.6.6A.606.606,0,0,0,403.749,488.144Z",
    transform: "translate(-402.66 -487.66)",
    stroke: "#898d93",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17114",
    "data-name": "Group 17114",
    transform: "translate(168.179 213.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38268",
    "data-name": "Path 38268",
    d: "M532.449,618.538a1.089,1.089,0,1,1,1.089-1.089A1.09,1.09,0,0,1,532.449,618.538Zm0-1.694a.6.6,0,1,0,.6.6A.606.606,0,0,0,532.449,616.844Z",
    transform: "translate(-531.36 -616.36)",
    stroke: "#898d93",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17115",
    "data-name": "Group 17115",
    transform: "translate(159.17 204.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38269",
    "data-name": "Path 38269",
    d: "M172.888,262.061h-12.6a1.118,1.118,0,0,1-1.117-1.117V249.093a.894.894,0,0,1,.893-.893h2.755a.242.242,0,0,1,.242.242v.848h.7v-.848a.242.242,0,0,1,.242-.242h7.407a.242.242,0,0,1,.242.242v.848h.7v-.848a.242.242,0,0,1,.242-.242h2.755a.894.894,0,0,1,.893.893v9.6a.241.241,0,0,1-.071.171l-3.121,3.122A.243.243,0,0,1,172.888,262.061Zm-12.825-13.377a.409.409,0,0,0-.409.409v11.851a.634.634,0,0,0,.633.633h12.5l2.98-2.979v-9.5a.409.409,0,0,0-.409-.409h-2.513v.848a.242.242,0,0,1-.242.242h-1.189a.242.242,0,0,1-.242-.242v-.848h-6.923v.848a.242.242,0,0,1-.242.242h-1.189a.242.242,0,0,1-.242-.242v-.848Z",
    transform: "translate(-159.17 -248.2)",
    stroke: "#898d93",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17116",
    "data-name": "Group 17116",
    transform: "translate(159.412 207.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38270",
    "data-name": "Path 38270",
    d: "M169.17,378.63h16.6v.484h-16.6Z",
    transform: "translate(-169.17 -378.63)",
    stroke: "#898d93",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17117",
    "data-name": "Group 17117",
    transform: "translate(162.576 203.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38271",
    "data-name": "Path 38271",
    d: "M301.311,205.834h-1.189a.242.242,0,0,1-.242-.242v-2.18a.242.242,0,0,1,.242-.242h1.189a.242.242,0,0,1,.242.242v2.18A.242.242,0,0,1,301.311,205.834Zm-.947-.484h.7v-1.7h-.7Z",
    transform: "translate(-299.88 -203.17)",
    stroke: "#898d93",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17118",
    "data-name": "Group 17118",
    transform: "translate(171.172 203.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38272",
    "data-name": "Path 38272",
    d: "M656.431,205.834h-1.189a.242.242,0,0,1-.242-.242v-2.18a.242.242,0,0,1,.242-.242h1.189a.242.242,0,0,1,.242.242v2.18A.242.242,0,0,1,656.431,205.834Zm-.947-.484h.7v-1.7h-.7Z",
    transform: "translate(-655 -203.17)",
    stroke: "#898d93",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17119",
    "data-name": "Group 17119",
    transform: "translate(172.646 214.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38273",
    "data-name": "Path 38273",
    d: "M716.132,675.485a.242.242,0,0,1-.242-.242v-2.471a.894.894,0,0,1,.893-.893h2.47a.242.242,0,0,1,.171.413l-3.121,3.121A.242.242,0,0,1,716.132,675.485Zm.651-3.121a.409.409,0,0,0-.409.409v1.886l2.295-2.295Z",
    transform: "translate(-715.89 -671.88)",
    stroke: "#898d93",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.ac9f1407.svg";
export { ForwardRef as ReactComponent };